import { Button, InformationCard, Text } from '@yes.technology/react-toolkit'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18n-lite'
import styled from 'styled-components'
import useFetchSuggestions from 'modules/interaction/hooks/useFetchSuggestions'

const CategoryList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 300px;
  overflow-y: auto;
  flex: 1;
`

const CategoryItem = styled.li<{ selected: boolean }>`
  padding: 0.75rem 1rem;
  border: 2px solid
    ${({ selected }) => (selected ? 'var(--blue-emphasis)' : '#e0e0e0')};
  border-radius: 8px;
  cursor: pointer;
  background-color: ${({ selected }) =>
    selected ? 'var(--blue-emphasis-10, #e8f0fe)' : 'transparent'};

  &:hover {
    border-color: var(--blue-emphasis);
  }
`

const ButtonRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
`

export type MarkingCategory = {
  uuid: string
  des: string
}

type MarkingCategoryModalProps = {
  isOpen: boolean
  categoriesFilteraction: string
  parentPath: string[]
  selectedCategory: MarkingCategory | null
  onSelectCategory: (category: MarkingCategory) => void
  onConfirm: () => void
  onCancel: () => void
  categorySelectionModal?: { des: string; complement?: string }
}

const MarkingCategoryModal = ({
  isOpen,
  categoriesFilteraction,
  parentPath,
  selectedCategory,
  onSelectCategory,
  onConfirm,
  onCancel,
  categorySelectionModal
}: MarkingCategoryModalProps) => {
  const { t } = useTranslation()
  const { suggestions, fetchSuggestions } = useFetchSuggestions({
    parentPath,
    filteraction: categoriesFilteraction,
    showLoading: false
  })

  useEffect(() => {
    if (categoriesFilteraction) {
      fetchSuggestions('.*')
    }
  }, [isOpen, categoriesFilteraction, fetchSuggestions])

  return (
    <InformationCard
      isOpen={isOpen}
      title={
        categorySelectionModal?.des ??
        t('activity-document-photo.mark-photo.marking-category-title')
      }
      close={onCancel}
      style={{
        width: '100%',
        maxWidth: '400px',
        position: 'fixed',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        margin: 0,
        zIndex: 1100,
        display: 'flex',
        maxHeight: '100%',
        flexDirection: 'column'
      }}
    >
      <Text variant='label-02'>
        {categorySelectionModal?.complement ??
          t('activity-document-photo.mark-photo.marking-category-subtitle')}
      </Text>
      <CategoryList>
        {suggestions.map((suggestion) => (
          <CategoryItem
            key={suggestion.uuid}
            selected={selectedCategory?.uuid === suggestion.uuid}
            onClick={() =>
              onSelectCategory({ uuid: suggestion.uuid, des: suggestion.des })
            }
          >
            <Text variant='label-02'>{suggestion.des}</Text>
          </CategoryItem>
        ))}
      </CategoryList>
      <ButtonRow>
        <Button onClick={onConfirm} disabled={!selectedCategory}>
          {t('activity-document-photo.mark-photo.confirm')}
        </Button>
        <Button variant='secondary' onClick={onCancel}>
          {t('activity-document-photo.mark-photo.cancel')}
        </Button>
      </ButtonRow>
    </InformationCard>
  )
}

export default MarkingCategoryModal
